import {User} from "./user";

export class Picture {
  activated:boolean;

  creationDate: number;

  id:number;

  height:number = 0;

  miniatureHeight:number = 0;

  miniatureUrl: string;

  miniatureWidth:number = 0;

  nbComments: number;

  owner:User;

  url: string = "";

  width:number = 0;

  downloadUrl:string;

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/model/picture.ts